// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__9qIvo","content":"styles_content__QG597"};